import axios from 'axios'
import store from '../store'
import http from './http.service'

class AuthService {
  login (user) {
    return axios
      .post(store.getters['api/authLogin'], {
        phone: user.phone,
        password: user.password,
      })
      .then((response) => {
        this.storeSession(response.data)

        return response.data
      })
  }

  // Вход под сотрудником: ответ той же формы, что у login, сессия сохраняется тем же кодом
  loginAs (userId) {
    return http
      .post(`/users/${userId}/login-as`)
      .then((response) => {
        this.storeSession(response.data)

        return response.data
      })
  }

  storeSession (data) {
    if (!data.token) {
      return
    }

    const EXPIRES_TIME = parseInt(new Date().getTime() / 1000) + 3600
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`
    localStorage.setItem('user', JSON.stringify(data))
    if (data.data && data.data.filials) {
      localStorage.setItem('userFilials', JSON.stringify(data.data.filials))
    } else {
      localStorage.setItem('userFilials', JSON.stringify([]))
    }
    localStorage.setItem('expires_in', EXPIRES_TIME)
  }

  whoami () {
    return axios
      .post(store.getters['api/authMe'])
      .then((response) => {
        if (response.data && response.data.data && response.data.data.filials) {
          localStorage.setItem('userFilials', JSON.stringify(response.data.data.filials))
        } else {
          localStorage.setItem('userFilials', JSON.stringify([]))
        }

        return response.data
      })
  }

  logout () {
    axios.defaults.headers.common.Authorization = ''
    localStorage.removeItem('user')
  }
}

export default new AuthService()
